// GENERATED FILE - DO NOT MODIFY

export enum LocationTypeDto {
    Heyday = "Heyday",
    Passport = "Passport",
}